import React, { useEffect, useState } from 'react';
import { useUserContext } from '../../../../context/UserContext';
import NotificationList from '../NotificationList/NotificationList';
import NotificationDetail from '../NotificationDetail/NotificationDetail';
import MobileHeader from '../../../../components/MobileHeader';
import styles from './InboxNotificationsContent.module.scss';
import Content from '../../../../components/Content/Content';
import { useMessageContext } from '../../../../context/MessageContext';
import { useLocation, useHistory } from 'react-router-dom';

export default function InboxNotificationsContent() {
  const { user } = useUserContext();
  const {
    messages,
    messageDetails,
    showReleaseAnnouncement,
    setShowReleaseAnnouncement,
    fetchMessagesOnInit,
    setMessageDetailsById,
  } = useMessageContext();

  const [showNotificationDetail, setShowNotificationDetail] = useState(null);

  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const shouldFetchList = queryParams.get('id') === null;

    if (!messages?.length && queryParams.get('id') !== null) {
      history.goBack();
    }

    if (queryParams.get('type') === 'release_announcement') {
      shouldFetchList && fetchMessagesOnInit({ type: 'release_announcement' });
      setShowReleaseAnnouncement(true);
    } else {
      shouldFetchList && fetchMessagesOnInit();
      setShowReleaseAnnouncement(false);
    }
    setShowNotificationDetail(queryParams.get('id'));
  }, [location]);

  useEffect(() => {
    if (showNotificationDetail !== null && !Object.keys(messageDetails).length && messages.length) {
      setMessageDetailsById(showNotificationDetail);
    }
  }, [messages, messageDetails, showNotificationDetail]);

  return (
    <>
      <MobileHeader libraryMode={false} userAvatar={user?.avatarUri} userFirstLetter={user?.userFullName.charAt(0).toUpperCase()} />
      <Content className={styles.content} triggerManualAnimation={showReleaseAnnouncement}>
        {showNotificationDetail !== null ? <NotificationDetail /> : <NotificationList />}
      </Content>
    </>
  );
}
